import { keepPreviousData, useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useQSBuilder from "../../hooks/useQSBuilder";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ITicketSummary } from "../../models/Tickets/Ticket";
import { TicketQueryKeys } from "./keys";

export interface IUseTicketSummaryProps {
  searchTerm?: string;
  customerId?: string;
}

/**
 * Counts behind the summary bar. Only customer and search scope are passed - the
 * tiles deliberately keep showing where everything sits while a filter is applied.
 */
export default function useTicketSummary({
  searchTerm,
  customerId,
}: IUseTicketSummaryProps = {}) {
  const { get } = useApiHelper();
  const buildQS = useQSBuilder();

  const params: Record<string, string> = {};
  if (searchTerm) params.searchTerm = searchTerm;
  if (customerId) params.customerId = customerId;

  const queryString = buildQS(params);

  const summary = useQuery({
    queryKey: [...TicketQueryKeys.summary(), queryString],
    queryFn: () =>
      get<IDefaultResponse<ITicketSummary>>(`/ticket/summary${queryString}`).then(
        (res) => res.data,
      ),
    placeholderData: keepPreviousData,
  });

  return {
    summary,
  };
}
